// @ts-ignore
import React, { useState } from "react";
import { NewModal } from "../uiMerge/newModal";
import PollIcon from "../../assets/svg/pollIcon.svg";
import Button from "../uiMerge/newButton";

type SurveyModalProps = {
  visible: boolean;
  onCancel: () => void;
  userName: string;
  question: string;
  pollOptions: string[];
  onSubmit: (option: string) => void;
};

const SurveyModal = ({
  visible,
  onCancel,
  userName,
  question,
  pollOptions,
  onSubmit,
}: SurveyModalProps) => {
  const [selected, setSelected] = useState<string | null>(null);

  // If admin hasn’t provided options yet, don’t render options
  const hasOptions = Array.isArray(pollOptions) && pollOptions.length > 0;

  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-t-[25px]"
      colorClass="bg-black"
      heightClass="h-auto"
      position="end"
      showCloseButton
      closeButtonClassName="!pt-3 !pr-2"
      onClose={onCancel}
    >
      <div className="relative w-full max-w-md bg-gradient-to-b from-[#EDEBFF] to-[#C9B6FF] rounded-t-3xl p-5 pb-6">
        <div className="absolute top-3 right-1 w-[90px] h-[90px]">
          <img src={PollIcon} alt="poll" className="object-contain" />
        </div>
        <div className="flex flex-col gap-4 mb-4 mt-8">
          <p className="text-[15px] text-[#281289] mb-2">Hi {userName},</p>

          <h2 className="text-[19px] w-[70%] font-semibold text-[#281289] mb-4">
            {question}
          </h2>
        </div>

        {/* OPTIONS */}
        {hasOptions ? (
          <div className="space-y-3">
            {pollOptions.map((option) => (
              <label
                key={option}
                className={`flex items-center text-[#281289] gap-3 p-4 rounded-xl cursor-pointer border ${
                  selected === option
                    ? "border-[#4F46E5] bg-white"
                    : "bg-white/70"
                }`}
              >
                <div className="flex items-center rounded-xl cursor-pointer">
                  {/* RADIO */}
                  <div className="mr-3">
                    <div className="relative w-5 h-5 flex items-center justify-center">
                      <input
                        type="radio"
                        name="survey"
                        checked={selected === option}
                        onChange={() => {
                          setSelected(option);
                        }}
                        className="appearance-none w-4 h-4 rounded-full border-2 border-[#3B2FA3]"
                      />

                      {selected === option && (
                        <div className="absolute w-2 h-2 bg-[#3B2FA3] rounded-full" />
                      )}
                    </div>
                  </div>

                  {/* TEXT */}
                  <span className="text-[15px] text-[#281289]">{option}</span>
                </div>
              </label>
            ))}
          </div>
        ) : (
          <div className="text-center text-[13px] text-[#281289] py-6">
            No options available
          </div>
        )}

        {/* BUTTON */}
        <Button
          className="w-full rounded-xl mt-5"
          onClick={() => {
            if (!selected) return;

            onSubmit(selected);
          }}
          variant="primary"
        >
          Submit
        </Button>

        {/* DISMISS */}
        <button
          onClick={onCancel}
          className="block mx-auto mt-3 text-[13px] underline"
        >
          Dismiss
        </button>
      </div>
    </NewModal>
  );
};

export default SurveyModal;
